// @todo move to secret manager in AWS and get needed credentials on Start
console.log(location.hostname)

export const stripeConfig = {
  apiKey:
    (location.hostname.toString().trim() === ("localhost").toString().trim())
      ? "pk_test_GXBMZpgXHIX9R4uTPB3xfyKt"
      : "pk_live_xHf4gUcdEqbQra1oxSlyV4qq"
};

// pk_live_xHf4gUcdEqbQra1oxSlyV4qq
// pk_test_TYooMQauvdEDq54NiTphI7jx


// WEBPACK FOOTER //
// ./src/config/stripe.ts